var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.visible,
        width: "800px",
        top: "3%",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "address",
        },
        [
          _c("div", { staticClass: "address_book" }, [
            _c("div", { staticClass: "address_book_left" }, [
              _c(
                "div",
                { staticClass: "address_book_left_search" },
                [
                  _vm.type.includes(0) && _vm.type.length === 1
                    ? [
                        _c(
                          "el-input",
                          {
                            staticClass: "input-with-select",
                            attrs: {
                              clearable: "",
                              placeholder: "请输入部门名称",
                              size: "small",
                            },
                            on: { clear: _vm.handleSearch },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                return _vm.handleSearch.apply(null, arguments)
                              },
                            },
                            model: {
                              value: _vm.search,
                              callback: function ($$v) {
                                _vm.search = $$v
                              },
                              expression: "search",
                            },
                          },
                          [
                            _c("el-button", {
                              attrs: { slot: "append", icon: "el-icon-search" },
                              on: { click: _vm.handleSearch },
                              slot: "append",
                            }),
                          ],
                          1
                        ),
                      ]
                    : [
                        _c(
                          "el-input",
                          {
                            staticClass: "input-with-select",
                            attrs: {
                              clearable: "",
                              placeholder: "请输入",
                              size: "small",
                            },
                            on: { clear: _vm.handleSearch },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                return _vm.handleSearch.apply(null, arguments)
                              },
                            },
                            model: {
                              value: _vm.search,
                              callback: function ($$v) {
                                _vm.search = $$v
                              },
                              expression: "search",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "w-100",
                                attrs: {
                                  slot: "prepend",
                                  placeholder: "请选择",
                                },
                                slot: "prepend",
                                model: {
                                  value: _vm.select,
                                  callback: function ($$v) {
                                    _vm.select = $$v
                                  },
                                  expression: "select",
                                },
                              },
                              [
                                _c("el-option", {
                                  attrs: {
                                    label: "用户姓名",
                                    value: "nickName",
                                  },
                                }),
                                _c("el-option", {
                                  attrs: { label: "手机号码", value: "phone" },
                                }),
                              ],
                              1
                            ),
                            _c("el-button", {
                              attrs: { slot: "append", icon: "el-icon-search" },
                              on: { click: _vm.handleSearch },
                              slot: "append",
                            }),
                          ],
                          1
                        ),
                      ],
                ],
                2
              ),
              _c(
                "div",
                { staticClass: "crumbs" },
                _vm._l(_vm.crumbs, function (item, index) {
                  return _c(
                    "span",
                    { key: `crumbs_${item.deptId}`, staticClass: "crumbsView" },
                    [
                      _c(
                        "span",
                        {
                          class:
                            index === _vm.crumbs.length - 1 ? "colorBlue" : "",
                          on: {
                            click: function ($event) {
                              return _vm.changeCrumbs(item, index)
                            },
                          },
                        },
                        [_vm._v(_vm._s(item.name) + " ")]
                      ),
                      index !== _vm.crumbs.length - 1
                        ? _c("span", { staticClass: "m-r-5" }, [_vm._v("/")])
                        : _vm._e(),
                    ]
                  )
                }),
                0
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "infinite-scroll",
                      rawName: "v-infinite-scroll",
                      value: _vm.load,
                      expression: "load",
                    },
                  ],
                  staticClass: "addressBooks",
                  staticStyle: { overflow: "auto" },
                  attrs: { "infinite-scroll-disabled": "disabled" },
                },
                [
                  _vm._l(_vm.depts, function (item) {
                    return _c(
                      "div",
                      {
                        key: `dept_${item.deptId}`,
                        staticClass: "addressBooksBox",
                        on: {
                          click: function ($event) {
                            return _vm.changeDept(item)
                          },
                        },
                      },
                      [
                        _vm.disabledDept.includes(item.deptId) ||
                        item.status === 1
                          ? [
                              _vm.type.includes(0)
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "disabled",
                                      class: _vm.multiple
                                        ? "checkBox"
                                        : "checkBoxRadio",
                                    },
                                    [
                                      _vm.checkDeptIds.includes(item.deptId)
                                        ? _c("svg-icon", {
                                            attrs: { "icon-class": "gou" },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          : [
                              _vm.type.includes(0)
                                ? _c(
                                    "span",
                                    {
                                      class: _vm.multiple
                                        ? "checkBox"
                                        : "checkBoxRadio",
                                    },
                                    [
                                      _vm.checkDeptIds.includes(item.deptId)
                                        ? _c("svg-icon", {
                                            attrs: { "icon-class": "gou" },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                        _c("span", { staticClass: "checkName" }, [
                          _vm._v(_vm._s(item.name)),
                        ]),
                        _c(
                          "span",
                          {
                            staticClass: "next",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.goToNext(item)
                              },
                            },
                          },
                          [_vm._v("下级")]
                        ),
                      ],
                      2
                    )
                  }),
                  _c(
                    "div",
                    { staticClass: "userAddressBooks" },
                    _vm._l(_vm.users, function (item, index) {
                      return _c(
                        "div",
                        { key: `user_${item.userId}_${index}` },
                        [
                          _c(
                            "div",
                            { staticClass: "addressBooksBox" },
                            [
                              _vm.disabledUser.includes(item.userId)
                                ? [
                                    _vm.type.includes(1)
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "disabled",
                                            class: _vm.multiple
                                              ? "checkBox"
                                              : "checkBoxRadio",
                                          },
                                          [
                                            _vm.checkUserIds.includes(
                                              item.userId
                                            )
                                              ? _c("svg-icon", {
                                                  attrs: {
                                                    "icon-class": "gou",
                                                  },
                                                })
                                              : _vm._e(),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                : [
                                    _vm.type.includes(1)
                                      ? _c(
                                          "span",
                                          {
                                            class: _vm.multiple
                                              ? "checkBox"
                                              : "checkBoxRadio",
                                            on: {
                                              click: function ($event) {
                                                return _vm.changeUser(item)
                                              },
                                            },
                                          },
                                          [
                                            _vm.checkUserIds.includes(
                                              item.userId
                                            )
                                              ? _c("svg-icon", {
                                                  attrs: {
                                                    "icon-class": "gou",
                                                  },
                                                })
                                              : _vm._e(),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                              _c(
                                "div",
                                {
                                  staticClass: "checkName",
                                  on: {
                                    click: function ($event) {
                                      return _vm.changeUser(item)
                                    },
                                  },
                                },
                                [
                                  _c("AppAvatar", {
                                    staticClass: "m-r-5",
                                    attrs: {
                                      avatar: item.avatar,
                                      name: item.nickName,
                                      width: 34,
                                      "no-name": true,
                                    },
                                  }),
                                  _c("div", { staticClass: "userInfo" }, [
                                    _c(
                                      "div",
                                      { staticClass: "checkName" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "userName" },
                                          [
                                            _vm._v(
                                              _vm._s(item.nickName || item.name)
                                            ),
                                          ]
                                        ),
                                        item.status === 1
                                          ? _c(
                                              "el-tag",
                                              {
                                                staticClass: "m-l-10",
                                                attrs: {
                                                  type: "danger",
                                                  size: "mini",
                                                },
                                              },
                                              [_vm._v("离职")]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "userInfoDetail" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "userInfoDetailForm flex",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "userInfoDetailFormLabel",
                                              },
                                              [_vm._v("手机号：")]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "userInfoDetailFormValue",
                                              },
                                              [
                                                _c("tablePhoneItem", {
                                                  attrs: {
                                                    "row-data": {
                                                      uid: item.userId,
                                                    },
                                                    type: "system",
                                                  },
                                                  model: {
                                                    value: item.phoneNumber,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "phoneNumber",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "item.phoneNumber",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    placement: "right",
                                    width: "300",
                                    trigger: "hover",
                                  },
                                },
                                [
                                  _c("div", { staticClass: "userDetailCard" }, [
                                    _c(
                                      "div",
                                      { staticClass: "userDetailCard_header" },
                                      [
                                        _c("AppAvatar", {
                                          staticClass: "m-r-5",
                                          attrs: {
                                            avatar: item.avatar,
                                            name: item.nickName,
                                            width: 34,
                                            "no-name": true,
                                          },
                                        }),
                                        _c("div", { staticClass: "m-l-10" }, [
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(item.nickName || item.name)
                                            ),
                                          ]),
                                          _c(
                                            "div",
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "uid:" + _vm._s(item.userId)
                                                ),
                                              ]),
                                              item.status === 1
                                                ? _c(
                                                    "el-tag",
                                                    {
                                                      staticClass: "m-l-10",
                                                      attrs: {
                                                        type: "danger",
                                                        size: "mini",
                                                      },
                                                    },
                                                    [_vm._v("离职")]
                                                  )
                                                : _c(
                                                    "el-tag",
                                                    {
                                                      staticClass: "m-l-10",
                                                      attrs: { size: "mini" },
                                                    },
                                                    [_vm._v("在职")]
                                                  ),
                                            ],
                                            1
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "userDetailCardForm" },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "userDetailCardLabel",
                                          },
                                          [_vm._v("所属部门:")]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "userDetailCardValue",
                                          },
                                          [_vm._v(_vm._s(item.deptName))]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "userDetailCardForm" },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "userDetailCardLabel",
                                          },
                                          [_vm._v("手机号码:")]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "userDetailCardValue",
                                          },
                                          [_vm._v(_vm._s(item.phoneNumber))]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "userDetailCardForm" },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "userDetailCardLabel",
                                          },
                                          [_vm._v("角色:")]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "userDetailCardValue",
                                          },
                                          _vm._l(
                                            item.roleVoList,
                                            function (tag, i) {
                                              return _c(
                                                "el-tag",
                                                {
                                                  key: i,
                                                  attrs: { size: "mini" },
                                                },
                                                [_vm._v(_vm._s(tag.roleName))]
                                              )
                                            }
                                          ),
                                          1
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "next",
                                      attrs: { slot: "reference" },
                                      slot: "reference",
                                    },
                                    [_vm._v("详情")]
                                  ),
                                ]
                              ),
                            ],
                            2
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                  _vm.depts.length === 0 && _vm.users.length === 0
                    ? _c("div", { staticClass: "noData" }, [
                        _vm._v(" 暂无数据 "),
                      ])
                    : _vm._e(),
                ],
                2
              ),
            ]),
            _c(
              "div",
              { staticClass: "address_book_right" },
              [
                _vm.type.includes(1)
                  ? _vm._l(_vm.checkUser, function (item, index) {
                      return _c(
                        "div",
                        {
                          key: `${item.id}_${index}`,
                          staticClass: "checkList",
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(item.nickName || item.name)),
                          ]),
                          _c("i", {
                            staticClass: "el-icon-close",
                            on: {
                              click: function ($event) {
                                return _vm.delUserCheck(item, index)
                              },
                            },
                          }),
                        ]
                      )
                    })
                  : _vm._e(),
                _vm.type.includes(0)
                  ? _vm._l(_vm.checkDept, function (item, index) {
                      return _c(
                        "div",
                        {
                          key: `${item.id}_${index}`,
                          staticClass: "checkList",
                        },
                        [
                          _c("span", [_vm._v(_vm._s(item.name))]),
                          _c("i", {
                            staticClass: "el-icon-close",
                            on: {
                              click: function ($event) {
                                return _vm.delDeptCheck(item, index)
                              },
                            },
                          }),
                        ]
                      )
                    })
                  : _vm._e(),
              ],
              2
            ),
          ]),
          _c("div", { staticClass: "address_footer" }, [
            _c(
              "div",
              [
                _vm.ifCanCheck()
                  ? [
                      _vm.users.length > 0
                        ? [
                            _c(
                              "el-checkbox",
                              {
                                attrs: {
                                  value: _vm.checked,
                                  indeterminate: _vm.isIndeterminate,
                                },
                                on: { change: _vm.handleCheckAllChange },
                              },
                              [_vm._v("全选")]
                            ),
                            _c("span", [
                              _vm._v(
                                "(已选" +
                                  _vm._s(_vm.checkUserIds.length) +
                                  "项)"
                              ),
                            ]),
                          ]
                        : _vm._e(),
                    ]
                  : _vm._e(),
                _vm.isShowSelect
                  ? [
                      _c(
                        "div",
                        { staticClass: "inherit_select" },
                        [
                          _c("div", [_vm._v("企业微信")]),
                          _c("m-select", {
                            staticStyle: { width: "200px" },
                            attrs: {
                              "dict-key": "INHERIT_STATUS",
                              size: "mini",
                            },
                            model: {
                              value: _vm.qwInheritType,
                              callback: function ($$v) {
                                _vm.qwInheritType = $$v
                              },
                              expression: "qwInheritType",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
            _c(
              "div",
              { staticClass: "footer_btn" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.sure()
                      },
                    },
                  },
                  [_vm._v("确 定")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.cancel()
                      },
                    },
                  },
                  [_vm._v("取 消")]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }